import moment from "moment";
import { register } from "@rill/loader";

register(
  {
    name: "clientGoals",
    meta: ["no-bust", "client-goals"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const query = {
      proxyAthlete,
    };

    const res = await api("client-goals", { query });
    const resJson = await res.json();

    return resJson;
  }
);
